"use client"

import { useLocale, useTranslations } from "next-intl"
import Link from "next/link"

import Style from "./index.module.scss"

interface ErrorDisplayProps {
  error: Error
}

/**
 * 错误边界组件
 * @param error - 错误对象，包含错误信息
 */
export default function ErrorDisplay({ error }: ErrorDisplayProps) {
  const t = useTranslations("ErrorDisplay")
  const locale = useLocale()

  return (
    <>
      <div className={Style.errorContainer}>
        <svg width="440" height="360" viewBox="0 0 440 140" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Frame 1171275783">
            <ellipse
              id="Ellipse 1147"
              cx="210.5"
              cy="251.5"
              rx="208.5"
              ry="110.5"
              fill="url(#paint0_linear_3388_37244)"
            />
            <g id="Group 1171275825">
              <path
                id="Rectangle 34624831"
                d="M342 143.301L385.302 154.475V187.999L342 176.126V143.301Z"
                fill="url(#paint1_linear_3388_37244)"
              />
              <path
                id="Vector 1288"
                d="M406.952 132.127L364.698 122L342 143.651L384.952 154.825L406.952 132.127Z"
                fill="url(#paint2_linear_3388_37244)"
              />
              <path
                id="Rectangle 34624832"
                d="M406.953 132.129L385.302 153.78V187.304L406.953 162.859V132.129Z"
                fill="url(#paint3_linear_3388_37244)"
              />
            </g>
            <g id="Group 1171275826">
              <path
                id="Rectangle 34624829"
                d="M271 46.8594L329.667 61.9992V173.656L271 158.516V46.8594Z"
                fill="url(#paint4_linear_3388_37244)"
              />
              <path
                id="Vector 1287"
                d="M359 32.3043L301.753 18L271 48.5817L329.194 64.3658L359 32.3043Z"
                fill="url(#paint5_linear_3388_37244)"
              />
              <path
                id="Rectangle 34624830"
                d="M359 31.7227L329.667 61.0561V172.713L359 139.594V31.7227Z"
                fill="url(#paint6_linear_3388_37244)"
              />
              <path
                id="Vector 1289"
                d="M353.521 54.1505L335.177 71.6415C334.979 71.8302 334.867 72.0918 334.867 72.3652V73.8991C334.867 74.7727 335.909 75.2263 336.548 74.6313L354.892 57.5669C355.096 57.3777 355.211 57.1125 355.211 56.8347V54.8743C355.211 53.9948 354.158 53.5436 353.521 54.1505Z"
                fill="url(#paint7_linear_3388_37244)"
              />
              <path
                id="Vector 1290"
                d="M353.521 70.7091L335.177 88.2001C334.979 88.3888 334.867 88.6504 334.867 88.9238V90.4577C334.867 91.3313 335.909 91.7849 336.548 91.1899L354.892 74.1255C355.096 73.9363 355.211 73.6711 355.211 73.3933V71.4329C355.211 70.5534 354.158 70.1022 353.521 70.7091Z"
                fill="url(#paint8_linear_3388_37244)"
              />
              <path
                id="Vector 1291"
                d="M353.521 86.7951L335.177 104.286C334.979 104.475 334.867 104.736 334.867 105.01V106.544C334.867 107.417 335.909 107.871 336.548 107.276L354.892 90.2114C355.096 90.0223 355.211 89.757 355.211 89.4793V87.5188C355.211 86.6393 354.158 86.1882 353.521 86.7951Z"
                fill="url(#paint9_linear_3388_37244)"
              />
            </g>
            <g id="500">
              <path
                id="Vector"
                d="M302.443 167.672C278.891 167.672 263.531 147.192 263.531 121.592V121.336C263.531 95.736 279.147 75 302.699 75C326.123 75 341.611 95.48 341.611 121.08V121.336C341.611 146.936 325.995 167.672 302.443 167.672ZM302.699 153.464C316.651 153.464 325.355 139.256 325.355 121.592V121.336C325.355 103.672 316.267 89.208 302.443 89.208C288.619 89.208 279.787 103.288 279.787 121.08V121.336C279.787 139 288.747 153.464 302.699 153.464Z"
                fill="url(#paint10_linear_3388_37244)"
              />
              <path
                id="Vector_2"
                d="M213.818 167.668C190.266 167.668 174.906 147.188 174.906 121.588V121.332C174.906 95.7321 190.522 74.9961 214.074 74.9961C237.498 74.9961 252.986 95.4761 252.986 121.076V121.332C252.986 146.932 237.37 167.668 213.818 167.668ZM214.074 153.46C228.026 153.46 236.73 139.252 236.73 121.588V121.332C236.73 103.668 227.642 89.2041 213.818 89.2041C199.994 89.2041 191.162 103.284 191.162 121.076V121.332C191.162 138.996 200.122 153.46 214.074 153.46Z"
                fill="url(#paint11_linear_3388_37244)"
              />
              <path
                id="Vector_3"
                d="M130.896 167.667C121.673 167.667 112 163.5 106 157C100 150.5 96 142 96 142H112.5C112.5 142 122.448 153.331 130.768 153.331C141.52 153.331 148.56 147.187 148.56 137.843V137.587C148.56 128.499 140.88 122.739 130 122.739C123.6 122.739 118.096 124.531 113.488 126.707L104.016 120.435L106.576 76.5312H160.08V90.4833H120.144L118.736 111.475C122.96 109.939 126.928 108.915 132.944 108.915C150.352 108.915 164.048 118.131 164.048 137.075V137.331C164.048 155.635 150.736 167.667 130.896 167.667Z"
                fill="url(#paint12_linear_3388_37244)"
              />
            </g>
            <path
              id="Vector 1284"
              d="M271 73.9398C265.153 66.2297 248.037 59.5633 244.791 60.8045M244.791 60.8045C241.546 62.0457 235.525 62.7602 236.695 70.0847C237.285 73.7825 241.763 76.6383 246.441 73.9398C251.119 71.2412 249.767 61.6319 244.791 60.8045ZM244.791 60.8045C239.816 59.9771 234.166 58.3777 220.104 56.3093C206.042 54.241 199.768 50.1047 193.711 46.3812C188.865 43.4024 181.885 37.5552 179 35.0039"
              stroke="url(#paint13_linear_3388_37244)"
              strokeWidth="2"
              strokeDasharray="4 4"
            />
            <path
              id="Vector_4"
              d="M179.572 15.7835L144.957 11.1041C144.323 11.13 144.09 11.6477 144.233 12.0229L156.665 37.9982C156.807 38.3734 157.325 38.6063 157.629 38.2763L165.515 30.7764L172.788 34.6703C173.305 34.9032 173.797 34.502 173.655 34.1267L172.605 24.0078L179.999 16.9092C180.491 16.508 180.206 15.7575 179.572 15.7835ZM171.72 31.856L167.242 27.9747L153.433 16.473L170.891 24.0145L171.72 31.856Z"
              fill="#D7000F"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_3388_37244"
              x1="210.5"
              y1="59.3248"
              x2="209.274"
              y2="233.23"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#D7000F" stopOpacity="0.66" />
              <stop offset="1" stopColor="#FFDDE0" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_3388_37244"
              x1="385.302"
              y1="188.354"
              x2="329.419"
              y2="124.436"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" stopOpacity="0" />
              <stop offset="1" stopColor="#D7D7D8" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_3388_37244"
              x1="385.302"
              y1="154.825"
              x2="369.187"
              y2="90.2513"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" />
              <stop offset="1" stopColor="#D7D7D8" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_3388_37244"
              x1="385.302"
              y1="192.542"
              x2="424.927"
              y2="178.294"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" stopOpacity="0" />
              <stop offset="1" stopColor="#D7D7D8" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_3388_37244"
              x1="278.097"
              y1="121.139"
              x2="258.852"
              y2="27.3205"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" stopOpacity="0" />
              <stop offset="1" stopColor="#D7D7D8" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_3388_37244"
              x1="279.043"
              y1="67.8186"
              x2="418.198"
              y2="34.729"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" />
              <stop offset="1" stopColor="#D7D7D8" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_3388_37244"
              x1="352.093"
              y1="185.463"
              x2="425.362"
              y2="67.629"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" stopOpacity="0" />
              <stop offset="1" stopColor="#EFEFF1" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_3388_37244"
              x1="354.265"
              y1="72.4101"
              x2="339.91"
              y2="54.465"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" stopOpacity="0" />
              <stop offset="1" stopColor="#D7D7D8" />
            </linearGradient>
            <linearGradient
              id="paint8_linear_3388_37244"
              x1="354.265"
              y1="88.9687"
              x2="339.91"
              y2="71.0236"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" stopOpacity="0" />
              <stop offset="1" stopColor="#D7D7D8" />
            </linearGradient>
            <linearGradient
              id="paint9_linear_3388_37244"
              x1="354.265"
              y1="105.055"
              x2="339.91"
              y2="87.1096"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" stopOpacity="0" />
              <stop offset="1" stopColor="#D7D7D8" />
            </linearGradient>
            <linearGradient
              id="paint10_linear_3388_37244"
              x1="270.416"
              y1="68.8671"
              x2="350.817"
              y2="119.822"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" />
              <stop offset="1" stopColor="#D7D7D8" />
            </linearGradient>
            <linearGradient
              id="paint11_linear_3388_37244"
              x1="181.791"
              y1="68.8632"
              x2="262.192"
              y2="119.818"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" />
              <stop offset="1" stopColor="#D7D7D8" />
            </linearGradient>
            <linearGradient
              id="paint12_linear_3388_37244"
              x1="102"
              y1="70.5"
              x2="176.663"
              y2="112.434"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" />
              <stop offset="1" stopColor="#D7D7D8" />
            </linearGradient>
            <linearGradient
              id="paint13_linear_3388_37244"
              x1="186.843"
              y1="10.5099"
              x2="189.016"
              y2="110.114"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#D7000F" stopOpacity="0.6" />
              <stop offset="1" stopColor="#FFDDE0" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>

        <p className={Style.title}>{t("title")}</p>
        <p className={Style.desc}>{t("desc")}</p>

        <Link href={`/${locale}`} className={Style.backHomeBtn}>
          {t("backHome")}
        </Link>
      </div>
    </>
  )
}
